import {
    HttpResponse,
    ProductNotificationRuleModel,
    QueryModel,
    RequestParams,
    ProductNotificationRuleModelIEnumerableApiResultSuccess,
    ProductNotificationRuleModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ProductNotificationRulesDataService implements CrudService<ProductNotificationRuleModel, ProductNotificationRuleModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<ProductNotificationRuleModel>): Promise<CrudListResponse<ProductNotificationRuleModel>> {
        return ApiService.api.getProductNotificationRuleBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ProductNotificationRuleModel>> {
        return ApiService.api.getProductNotificationRuleById(id, params);
    }

    create(item: ProductNotificationRuleModel, params?: RequestParams): Promise<CrudResponse<ProductNotificationRuleModel>> {
        return ApiService.api.insertProductNotificationRule(item, params);
    }

    update(item: ProductNotificationRuleModel, params?: RequestParams): Promise<ProductNotificationRuleModel> {
        return ApiService.api.updateProductNotificationRule(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ProductNotificationRuleModel> {
        return ApiService.api.patchProductNotificationRule(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ProductNotificationRuleModel>): Promise<CrudListResponse<ProductNotificationRuleModel>> {
        return ApiService.api.deleteProductNotificationRules(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ProductNotificationRuleModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
